var QRCode = require('qrcode')
var qrcanvas = document.getElementById('qr-code')

if(qrcanvas) {
  QRCode.toCanvas(qrcanvas, qrcanvas.dataset['code'], { width: 300, height: 300}, function (error) {
    if (error) console.error(error)
  })
}
